<ul>
    <li *ngFor="let i of Pages">
        <button (click)="PageSelect(i)" [disabled]="i == page">
            {{ i + 1 }}
        </button>
    </li>
</ul>
